/** External partner destinations used by marketing / FAQ surfaces. */

export const chariotOnboardingGuide = () => 'https://help.givechariot.com/onboarding/onboarding-guide';
